import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
import DBOperationsComb from "src/utils/dbOperationsComb";

const tableName = Constants.enums.TABLES_NAME_ENUM.PROFILE_TABLE;

async function updateProfile(data, options = {}) {
  try {
    return await DBOperationsComb.updateData(
      tableName,
      data,
      options.offlineFirst ?? true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getProfile(id) {
  try {
    return await DBOperationsComb.getData(tableName, id, false);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getEmailsByDistributionGroup(groupId) {
  const config = {
    fetchDeleted: false,
    searchTxt: null,
    sortField: null,
    sortOrder: null,
    page: 0,
    rows: null,
    fetchAll: true,
    queryParams: [
      {
        field: "mail_distributions_list",
        value: groupId,
        opType: Constants.enums.COMPARISON_TYPE.JSON_CS
      }
    ]
  };

  try {
    const response = await DBOperationsComb.fetchData({
      tableName,
      ...config
    });

    if (response.error) {
      console.error(
        `Error fetching distribution emails:`,
        response.error.message
      );
      return [];
    }

    const emails = response.data?.map((row) => row.email) || [];
    return emails;
  } catch (error) {
    console.error(`Unexpected error fetching distribution emails:`, error);
    return [];
  }
}

async function getRoles() {
  try {
    const response = await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.USER_ROLES_TABLE,
        fetchAll: true
      },
      false
    );

    return response?.data || [];
  } catch (error) {
    console.error("getRoles error:", error);
    return [];
  }
}

async function getAccessGroups() {
  try {
    const response = await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.USER_ACCESS_GROUPS_TABLE,
        fetchAll: true
      },
      false
    );
    return response?.data || [];
  } catch (error) {
    console.error("getAccessGroups error:", error);
    return [];
  }
}

export default {
  updateProfile,
  getProfile,
  getEmailsByDistributionGroup,
  getRoles,
  getAccessGroups
};
